import { render, staticRenderFns } from "./single-review.vue?vue&type=template&id=1960b318&scoped=true&lang=pug&"
import script from "./single-review.vue?vue&type=script&lang=js&"
export * from "./single-review.vue?vue&type=script&lang=js&"
import style0 from "./single-review.vue?vue&type=style&index=0&id=1960b318&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1960b318",
  null
  
)

export default component.exports